import * as types from '../types'

const state = {
  loginInfo: {
    token: ''
  }
}

const mutations = {
  [types.LOGIN] (state, {token}) {
    state.loginInfo.token = token
    window.localStorage.setItem('token', token)
  },

  [types.LOGOUT] (state) {
    state.loginInfo.token = ''
    window.localStorage.removeItem('token')
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js